import { Typography } from 'enable-ui';

import { Invitee } from 'modules/calendar/core/type';

import { isEmpty } from 'lodash';

import { COLOR_CONFIG } from 'constants/color';

export const StatusSummary = ({ items }: { items: Invitee[] }) => {
  const { yes, no, awaiting } = items.reduce(
    (acc, item) => {
      const status = item.status || 'awaiting';

      acc[status] += 1;

      return acc;
    },
    { yes: 0, no: 0, awaiting: 0 },
  );

  const renderItem = (isShow: boolean, count: number, text: string) => {
    if (!isShow) return null;

    return (
      <>
        <Typography color={COLOR_CONFIG['neutral-text']}>•</Typography>{' '}
        <Typography variant="body-3" color={COLOR_CONFIG['neutral-text']}>
          {count} {text}
        </Typography>
      </>
    );
  };

  return (
    <>
      {renderItem(!isEmpty(yes), yes, 'yes')}
      {renderItem(!isEmpty(no), no, 'no')}
      <>
        <Typography color={COLOR_CONFIG['neutral-text']}>•</Typography>{' '}
        <Typography variant="body-3" color={COLOR_CONFIG['neutral-text']}>
          {awaiting} awaiting
        </Typography>
      </>
    </>
  );
};
